import React, { FunctionComponent } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import { Formik, Form } from "formik";
import { useStore } from "../../store/index";
import {useTerminalUsersStyles} from "././TerminalUser/useTerminalUsersStyle";
import * as yup from "yup";

type StatusUpdateDailogProps = {
  StatusUpdateDailogClose: () => void;
  closeDialog: () => void;
  loggedUserObject: any;
};

export const StatusUpdateDailog: FunctionComponent<StatusUpdateDailogProps> = ({
  StatusUpdateDailogClose,
  closeDialog,
  loggedUserObject
}) => {
  const classes = useTerminalUsersStyles();
  const [user] = useStore("auth", "user");
  const [loggedPosUsers, { updateLoggedUserStatus, getLoggedPosUsers }] = useStore("loggedPosUsers");

  const onStatusUpdation = async (values: any) => {
    if (loggedUserObject.islogin !== true) {
      const userUpdateData = {
        comment: values.comment,
        mediadeclare_id: loggedUserObject.id,
        terminal_id: loggedUserObject.terminal_id,
        updated_by: user.id,
        updated_at: new Date().toISOString(),
        action_description: "login status activated",
        // m_status: "active"
      };
      
      await updateLoggedUserStatus(
        loggedUserObject.mediadeclare_id,
        userUpdateData,
        "Active"
      );
      await getLoggedPosUsers();
      closeDialog();
    } else {
      const userUpdateData = {
        comment: values.comment,
        mediadeclare_id: loggedUserObject.id,
        terminal_id: loggedUserObject.terminal_id,
        updated_by: user.id,
        updated_at: new Date().toISOString(),
        action_description: "login status inactivated",
        // m_status: "Inactive"
      };
      
      await updateLoggedUserStatus(
        loggedUserObject.mediadeclare_id,
        userUpdateData,
        "Inactive"
      );
      await getLoggedPosUsers();
      closeDialog();
    }
  };
  return (
    <Dialog
      open
      
      aria-labelledby="alert-dialog-titles"
      aria-describedby="alert-dialog-descriptions"
    >
      <Formik
        enableReinitialize
        initialValues={{
          comment: ""
        }}
        validationSchema={yup.object().shape({
          comment: yup.string().required("Required")})}
        onSubmit={async values => {
          try {
            onStatusUpdation(values);
          } catch (error) {}
        }}
      >
        {({ values, handleChange }) => (
          <Form>
            <DialogContent>
              <DialogContentText>
                Would you like to change status of '{loggedUserObject.full_name}'
              </DialogContentText>

              <TextField
                className={classes.textFieldStyle}
                required
                multiline
                margin="dense"
                name="comment"
                onChange={handleChange}
                value={values.comment}
                label="Add  Comment"
                type="comment"
                fullWidth
              />
            </DialogContent>
            <DialogActions>
              <Button type="submit">
                {loggedUserObject.islogin !== true ? "Active" : "Inactive"}
              </Button>
              <Button onClick={StatusUpdateDailogClose}>Cancel</Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};
